export const Images = {
  stripe_logo: require('./IntegrationLogos/stripe-logo.svg').default,
  figma_logo: require('./IntegrationLogos/figma-logo.svg').default,
  github_logo: require('./IntegrationLogos/github-logo.svg').default,
  github_dark_logo: require('./IntegrationLogos/github-dark-logo.svg').default,
  sentry_logo: require('./IntegrationLogos/sentry-logo.svg').default,
  sentry_dark_logo: require('./IntegrationLogos/sentry-dark-logo.svg').default,
  teams_logo: require('./IntegrationLogos/teams-logo.svg').default,
  slack_logo: require('./IntegrationLogos/slack-logo.svg').default,
  make_logo: require('./IntegrationLogos/make-logo.svg').default,
  zapier_logo: require('./IntegrationLogos/zapier-logo.svg').default,
  api_logo: require('./IntegrationLogos/api-logo.svg').default,
  api_dark_logo: require('./IntegrationLogos/api-dark-logo.svg').default,
  vercel_logo: require('./IntegrationLogos/vercel-logo.svg').default,
  vercel_dark_logo: require('./IntegrationLogos/vercel-dark-logo.svg').default,

  // empty state
  empty_favicon_dark: require('./emptystates/emptyFaviconDark.svg').default,
  empty_favicon_light: require('./emptystates/emptyFaviconLight.svg').default,
  empty_brand_logo_light: require('./emptystates/emptyBrandLogoLight.svg').default,
  empty_brand_logo_dark: require('./emptystates/emptyBrandLogoDark.svg').default
};
